import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react/index';

@inject('store')
@observer
export class MarketStatus extends Component {
    render() {
        if (
            !this.props.store.botStore.tickersStore.tickers ||
            !this.props.store.botStore.currentConfiguration
        ) {
            return <div>Fetching price information...</div>;
        }

        const exchangeConfig = this.props.store.exchangeConfig[
            this.props.store.botStore.currentConfiguration.exchange
        ];

        return (
            <Fragment>
                {exchangeConfig.featured_markets.map(config => {
                    const symbol = `${config.base}/${config.quote}`;
                    const ticker = this.props.store.botStore.tickersStore.tickers[symbol];
                    if (!ticker) return null;

                    return (
                        <span key={config.base} style={{ width: 120, marginLeft: 5 }}>
                            <img
                                src={`/symbols/${config.base}.png`}
                                alt={`${config.base} logo`}
                                style={{ height: 20 }}
                            />
                            <span style={{ position: 'relative', margin: '0 5px', top: 1 }}>
                                ${ticker.last}
                                <span
                                    style={{ margin: '0 5px' }}
                                    className={ticker.percent_change > 0 ? 'success' : 'error'}
                                >
                                    ({ticker.percent_change.toFixed(2)}%)
                                </span>
                            </span>
                        </span>
                    );
                })}
            </Fragment>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Account/Bot/MarketStatus.js